
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/safe-ai-in-curipod",
      function () {
        return require("private-next-pages/safe-ai-in-curipod.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/safe-ai-in-curipod"])
      });
    }
  